export default {
  groupBuy: {
  productSource: 'Product source',
  sourceShopId: 'Store ID',
  productInfo: 'Product information',
  linkedProduct: 'Redemption product',
  linkStatus: 'Link status',
  linked: 'Linked',
  notLinked: 'Not linked',
  pulledTime: 'Product last updated',
  platformProductSearch: 'Product name, product ID or SKU ID',
  pullProducts: 'Fetch platform products',
  pullHistory: 'Fetch history',
  platformProductId: 'Product ID',
  platformSkuId: 'SKU ID',
  platformProductSkuId: 'Product ID / SKU ID',
  localProductUnavailable: 'Redemption product unavailable',
  linkProduct: 'Link product',
  editProductLink: 'Edit link',
  unlinkProduct: 'Unlink',
  applicableRange: 'Applicable stores',
  applicabilityUnknown: 'The platform did not provide the complete applicable store list',
  applicabilityHint: 'These are platform store IDs. This link applies only to the selected store.',
  noApplicableShops: 'The platform returned no applicable stores',
  awaitingPull: 'Awaiting fetch',
  metadataUnavailable: 'Platform product details are incomplete. Fetch again.',
  unsupportedProduct: 'This product type does not support ordinary voucher redemption',
  confirmProductUnlink: 'Unlink "{product}" in "{shop}"? Platform product details and accepted redemptions will be retained.',
  pullState: 'Fetch status',
  pulledCount: 'SKUs fetched',
  failureReason: 'Failure reason',
  pullStarted: 'Submitted at',
  pullSubmitted: 'Fetch submitted. View progress in Fetch history.',
  pullSelectionHint: 'Select bound stores with valid authorization to fetch all supported group-buy product listings. Up to 100 stores per batch.',
  backgroundPullHint: 'Fetching continues after closing the page. Retry failed stores individually. Existing product links are retained.',
  selectedPullShops: '{count} stores selected',
  retryPull: 'Retry',
  close: 'Close',
  startPull: 'Start fetching',
  localSelectionRequired: 'Select a redemption product variant and enter an integer quantity from 1 to 10000',
  localProductType: 'Redemption product type',
  ticketProduct: 'Tickets',
  coinProduct: 'Game coins',
  chooseLocalProduct: 'Select a redemption product',
  chooseLocalSku: 'Select a redemption product variant',
  quantityHint: 'The number of units of the selected product issued for each group-buy voucher redeemed.',
  saveProductLink: 'Save link',
  pullStates: {WAITING:'Waiting',RUNNING:'Fetching',SUCCEEDED:'Completed',FAILED:'Failed'},
  zhiJieShop: 'Store',
  shopCode: 'Store code',
  shopSearch: 'Search by store name, code or ID',
  bindingStatus: 'Binding status',
  bindingStates: { UNBOUND: 'Not bound', BOUND: 'Bound', UNAVAILABLE: 'Binding unavailable' },
  bindingUpdated: 'Binding updated',
  unavailableHelp: 'View why this binding is unavailable',
  platformShopId: 'Platform store ID',
  platformShopName: 'Platform store name',
  refreshList: 'Refresh list',
  bindNow: 'Bind now',
  changeBinding: 'Change binding',
  removeBinding: 'Unbind',
  bindShopTitle: 'Bind store',
  bindBelow: 'Bind stores in the list below',
  selectAuthorization: 'Select an authorized account',
  chooseAccount: 'Select an account',
  selectPlatformShop: 'Select a platform store',
  enterShopName: 'Enter platform store name',
  enterShopId: 'Enter platform store ID',
  select: 'Select',
  query: 'Search',
  reset: 'Reset',
  bind: 'Bind',
  saveChange: 'Save change',
  pageNumber: 'Page {page}',
  confirmShopRemove: 'Unbind "{shop}"? Other stores and accepted redemption records will be preserved.',
  applicableShops: 'Applicable store IDs',
  platformSku: 'Platform SKU',
  localShop: 'Store',
  selectShop: 'Select a store first',
  platformShop: 'Platform store',
  platformProduct: 'Group-buy product',
  localProduct: 'Redemption product',
  localSku: 'Redemption product variant',
  quantity: 'Units redeemed per voucher',
  account: 'Authorized account',
  addShop: 'Bind platform store',
  addProduct: 'Bind product SKU',
  edit: 'Edit',
  remove: 'Unbind',
  save: 'Save binding',
  cancel: 'Cancel',
  refresh: 'Refresh',
  loadMore: 'Load more',
  searchProduct: 'Search by product name',
  next: 'Next',
  previous: 'Previous',
  status: 'Availability',
  available: 'Configuration available',
  actions: 'Actions',
  unbound: 'No bindings found',
  confirmRemove: 'Unbind this item? Accepted redemptions keep their original delivery details.',
  selectRequired: 'Select the store, product SKU and quantity',
  loadFailed: 'Could not load. Please retry.',
  saved: 'Binding saved',
  removed: 'Binding removed',
  readOnly: 'Platform products are read only and mapped to local products. They are never published or edited.',
  shopUnique: 'Each ZhiJie store binds one platform store per platform. A Meituan store authorization can bind only one ZhiJie store.',
  productUnique: 'Each platform SKU has one binding per local store.',
  noAccount: 'Authorize the main account first',
  noPermission: 'You do not have permission to view bindings',
  business: 'Business',
  selectPlatform: 'Select a platform store to query products',
  configNeeded: 'Bind a platform store first',
  all: 'All platforms',
  history: {
    period: 'Submitted at',
    startTime: 'Start time',
    endTime: 'End time',
    rangeSeparator: 'to',
    platformAndProduct: 'Platform and product',
    quantity: 'Quantity',
    submittedCount: '{count} coupons submitted',
    quantityPerCoupon: '{count} units per coupon',
    shopId: 'Store ID',
    operatorId: 'Operator ID',
    loadingDetail: 'Loading coupon results',
    noCouponDetails: 'No coupon details available. Refresh the details to check again.',
    noMatches: 'No matching redemption records. Adjust or reset the filters and search again.',
    staleResults: 'Refresh failed. The last successful results remain visible.',
    staleDetail: 'Detail refresh failed. The last successful details remain visible.',
    summaryOnly: 'Only the list summary is available. Refresh details to load coupon results.',
    provider: 'Platform',
    processStatus: 'Processing status',
    processCounts: 'Processing progress',
    allProcessStatuses: 'All processing statuses',
    processStatuses: {
      VERIFYING: 'Redeeming',
      VERIFY_UNKNOWN: 'Redemption awaiting confirmation',
      FAILED: 'Redemption failed',
      DELIVERY_PENDING: 'Delivery pending',
      MANUAL_PENDING: 'Manual coins pending',
      COMPLETED: 'Completed',
      CANCELLING: 'Cancellation in progress',
      CANCELLED: 'Cancelled',
    },
    platformStatus: 'Redemption status',
    deliveryStatus: 'Delivery status',
    allPlatforms: 'All platforms',
    allPlatformStatuses: 'All redemption statuses',
    allDeliveryStatuses: 'All delivery statuses',
    batchNo: 'Batch number',
    platformProduct: 'Platform product',
    localProduct: 'Redemption product',
    rightsPerCoupon: 'Units per voucher',
    rightsPerCouponHint: 'The number of local product units issued for each redeemed platform voucher.',
    requestedVouchers: 'Coupons submitted',
    recipient: 'Recipient',
    shop: 'Store',
    operator: 'Operator',
    createTime: 'Submitted at',
    actions: 'Actions',
    viewDetail: 'View details',
    detailTitle: 'Redemption details',
    copyLabel: 'Copy {label}',
    copySuccess: '{label} copied',
    copyFailed: 'Copy failed. Please copy it manually.',
    reloadLocal: 'Refresh details',
    platformCounts: 'Redemption result',
    deliveryCounts: 'Benefit delivery',
    couponRecords: 'Coupon results',
    couponRecordCount: '{count} coupons',
    couponId: 'Platform coupon number',
    requestNo: 'Operation number',
    ownerId: 'Recipient ID',
    memberNo: 'Member number',
    member: 'Member',
    guest: 'Guest',
    failureReason: 'Failure reason',
    notIssued: 'Not issued',
    deliveryNoResult: 'Awaiting platform result',
    close: 'Close',
    loadFailed: 'Could not load redemption records. Please retry.',
    detailLoadFailed: 'Could not load redemption details. Please retry.',
    platformStatuses: {
      PROCESSING: 'Processing',
      SUCCEEDED: 'Redeemed',
      FAILED: 'Failed',
      UNKNOWN: 'Awaiting confirmation',
      CANCELLING: 'Reversing',
      CANCELLED: 'Reversed',
      CANCEL_UNKNOWN: 'Reversal unconfirmed',
    },
    deliveryStatuses: {
      PENDING: 'Pending delivery',
      DELIVERED: 'Delivered',
      MANUAL_PENDING: 'Manual coins pending',
      MANUAL_DONE: 'Coins delivered',
      REVOKED: 'Reclaimed',
    },
  },
},
};
